/**
 * Adds the `data-list-style-type` / `data-indent` attributes Plate needs to deserialize
 * `<li>` elements as list items. Plate only does this itself when pasting, so HTML loaded
 * via `value` or `deserialize` (e.g. notes saved before the serializer emitted them) would
 * otherwise lose its bullets.
 */
export const normalizeListHtml = (html: string): string => {
    if (!html || !html.includes('<li')) return html;

    const { body } = new DOMParser().parseFromString(html, 'text/html');

    body.querySelectorAll('li').forEach((li) => {
        if (!li.dataset.listStyleType) {
            const listParent = li.closest('ul, ol') as HTMLElement | null;
            const listStyleType =
                li.style.listStyleType ||
                listParent?.style.listStyleType ||
                (listParent?.tagName === 'OL' ? 'decimal' : 'disc');
            li.dataset.listStyleType = listStyleType;
        }

        if (!li.dataset.indent) {
            let indent = 0;
            let parent = li.parentElement;
            while (parent && parent !== body) {
                if (parent.tagName === 'UL' || parent.tagName === 'OL') indent++;
                parent = parent.parentElement;
            }
            li.dataset.indent = String(Math.max(indent, 1));
        }
    });

    return body.innerHTML;
};
